import { render } from "./videoPopup.vue?vue&type=template&id=11c7e1f9&scoped=true"
import script from "./videoPopup.vue?vue&type=script&lang=js"
export * from "./videoPopup.vue?vue&type=script&lang=js"

import "./videoPopup.vue?vue&type=style&index=0&id=11c7e1f9&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c7e1f9"]])

export default __exports__